import { render } from "./ModalDetailBankBook.vue?vue&type=template&id=f8f65f24&scoped=true"
import script from "./ModalDetailBankBook.vue?vue&type=script&lang=js"
export * from "./ModalDetailBankBook.vue?vue&type=script&lang=js"

import "./ModalDetailBankBook.vue?vue&type=style&index=0&id=f8f65f24&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f65f24"]])

export default __exports__